export default function useAppearance(_ref) {
  var {
    appearance,
    background,
    border
  } = _ref;
  switch (appearance) {
    case 'dropShadow':
      return {
        background: 'filled',
        border: 'dropShadow'
      };
    case 'outlined':
      return {
        background: 'transparent',
        border: 'outlined'
      };
  }
  switch (border) {
    case 'none':
      return {
        background: 'filled',
        border: 'none'
      };
    case 'dropShadow':
      return {
        background: 'filled',
        border: 'dropShadow'
      };
  }
  return {
    background,
    border
  };
}